<ng-container *transloco="let t; read: 'ime.manufacturing.manufacturing-graph-modal'">
  <div class="modal-header" ngxModalDraggable>
    <h4 class="modal-title pull-left">{{title}}</h4>
    <div class="ms-auto">
    </div>
    <button type="button" class="btn-close ms-2" aria-label="Close" (click)="bsModalRef.dismiss()">
    </button>
  </div>
  <div class="modal-body" style="height: calc(100vh - 130px); overflow: hidden">
    <app-graph-builder [graph]="graph"
                       [entityId]="item?.Id"
                       [masterOperations]="item?.MasterOperations ?? []"
                       [processSelectors]="item?.ProcessSelectors ?? []"></app-graph-builder>
  </div>
  <mes-web-edit-modal-buttons [entityId]="item?.Id"
                              [isPristine]="false"
                              (saveClick)="save($event)"
                              (cancelClick)="bsModalRef.dismiss()">
  </mes-web-edit-modal-buttons>
</ng-container>
